import React from "react";
import { useForm } from "react-hook-form";
import CustomSelect from "../../../components/common/FormFields/select";
import { customSelectStyles } from "../../../utils/helper";

const OrderFilter = ({
  onStatusChange,
  currentStatus,
  onProductChange,
  currentName,
  searchName,
}) => {
  const { setValue, control } = useForm({
    defaultValues: {
      status: currentStatus || "",
      productName: currentName || "",
    },
  });

  const statusOptions = [
    { label: "All", value: "all" },
    { label: "Payment Success", value: "PAYMENT_SUCCESS" },
    { label: "Payment Failed", value: "PAYMENT_FAILED" },
    { label: "Payment Pending", value: "PAYMENT_PENDING" },
    { label: "Cancelled", value: "CANCELLED" },
    { label: "Completed", value: "COMPLETED" },
  ];

  const handleProductChange = (selectedOption) => {
    const productValue = selectedOption?.value || "";
    setValue("productName", productValue);
    onProductChange(productValue);
  };

  const handleStatusChange = (selectedOption) => {
    const statusValue = selectedOption?.value || "";
    setValue("status", statusValue);
    onStatusChange(statusValue);
  };

  return (
    <form>
      <CustomSelect
        name="productName"
        placeholder="Select product name"
        onChange={handleProductChange}
        control={control}
        options={searchName}
        isClearable
        styles={customSelectStyles}
      />
      <CustomSelect
        control={control}
        name="status"
        options={statusOptions}
        placeholder="Select status"
        onChange={handleStatusChange}
        isClearable
        styles={customSelectStyles}
      />
    </form>
  );
};

export default OrderFilter;
